import { inject, Injectable } from '@angular/core';
import { RelativeDateStrategy } from './relative-date-strategy.service';
import { BaseSegmentedControlStrategy } from './base-segmented-control-strategy.service';
import { LogicStepParameterType } from '@wdx/shared/swagger-gen';
import { RelativePartyStrategy } from './relative-party-strategy.service';

@Injectable()
export class SegmentedControlStrategyRegistry {
    private readonly relativeDate = inject(RelativeDateStrategy);
    private readonly relativeParty = inject(RelativePartyStrategy);

    getStrategy(kind: LogicStepParameterType): BaseSegmentedControlStrategy {
        switch (kind) {
            case LogicStepParameterType.RelativeDate:
                return this.relativeDate;
            case LogicStepParameterType.RelativeParty:
                return this.relativeParty;
            default:
                throw new Error(
                    `No strategy for segmented control kind ${kind}`,
                );
        }
    }
}
